<template>
    <div class="row">
        <div class="col-md-4">
            <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Filtro" id="reglas-cobro-filter" v-model="filter" />

                <div class="input-group-append">
                    <button class="btn btn-primary" type="button" id="clean-filter" @click="clearFilter">
                        <i class="fas fa-redo"></i>
                    </button>
                </div>
            </div>
        </div>

        <table class="table table-hover table-borderless figma-table">
            <thead>
                <tr class="font-weight-bold text-center" style="background-color: #f3f3f3; color: #989898;">
                    <th scope="col">Método descuento</th>
                    <th scope="col">Descuento</th>
                    <th scope="col">Fecha de apertura</th>
                    <th scope="col">Fecha cierre</th>
                    <th scope="col">Abonos</th>
                    <th scope="col">Cargos</th>
                    <th scope="col">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in filterRegs" :key="item.id">
                    <td>
                        <div class="d-flex align-items-center">
                            <div
                                class="bpill rounded-circle d-inline-flex justify-content-center align-items-center mr-2"
                                :class="{
                                    'bpill--porcentaje': item.metodo_descuento.includes('porcentaje'),
                                    'bpill--monto': item.metodo_descuento.includes('monto')
                                }">
                                <span v-if="item.metodo_descuento.includes('porcentaje')">P</span>
                                <span v-if="item.metodo_descuento.includes('monto')">M</span>
                            </div>
                            <div>{{ item.metodo_descuento.toUpperCase() }}</div>
                        </div>
                    </td>
                    <td class="text-right">
                        <strong>{{ item.metodo_descuento =='porcentaje' ? item.porcentaje+'%': '$'+item.monto }}</strong>
                        <p class="text-muted">{{ item.programa ? item.programa.nombre : item.nivel_academico ? item.nivel_academico.nivel : '' }}</p>
                    </td>
                    <td class="text-right">
                        <i class="far fa-calendar"></i>
                        {{ item.fecha_apertura }}
                    </td>
                    <td class="text-right">
                        <i class="far fa-calendar"></i>
                        {{ item.fecha_cierre }}
                    </td>
                    <td class="text-right">
                        <strong>{{ item.abonos.nombre }}</strong><br>
                        <span>{{ item.abonos.clave }} {{ 'gravable: '+ item.abonos.gravable }}</span>
                    </td>
                    <td class="text-right">
                        <strong>{{ item.cargos.nombre }}</strong><br>
                        <span>{{ item.cargos.clave }} {{ 'gravable: '+ item.cargos.gravable }}</span>
                    </td>
                    <td>
                        <button data-toggle="modal" data-target="#editar_promocion_Modal" type="button" class="fbutton fbutton--edit editar-regla-cobro rounded-circle d-flex-inline justify-content-center" @click="editPromocion(item.id)">
                            <i class="fas fa-edit"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <Editar :promocionId="selectedPromocionId" />
    </div>
</template>

<script>
  import Editar from './Editar.vue';

    export default {
      components: {
        Editar
      },
        props: {
            regs: {
                type: Array,
                default: []
            },
        },
        methods: {
            clearFilter() {
                this.filter = '';
            },
            editPromocion(promocionId) {
              this.selectedPromocionId = promocionId;
            },
        },
        data() {
            return {
                filter: '',
                selectedPromocionId: 0
            }
        },
        computed: {
            filterRegs() {
                if (this.filter) {
                    return this.regs.filter(reg => {
                        const filterBy = [
                            reg.metodo_descuento,
                            reg.porcentaje || 0,
                            reg.monto || 0,
                            reg.fecha_apertura,
                            reg.fecha_cierre,
                            reg.abonos.nombre,
                            reg.cargos.nombre
                        ];

                        const sfilterBy = filterBy.map(x => x.toString().toLowerCase());

                        return sfilterBy.some(camp => camp.includes(this.filter.toLowerCase()));
                    });
                }

                return this.regs;
            }
        },
    }
</script>

<style lang="scss" scoped>
.figma-table {
    .bpill {
        color: white;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
    }

    .bpill--servicio {
        background-color: purple;
    }

    .bpill--porcentaje {
        background-color: #5dade2;
    }

    .bpill--monto {
        background-color: #f39c12;
    }

    thead th {
        padding: 20px;
    }

    thead th:first-child {
        border-top-left-radius: 20px;
        width: 180px;
    }

    thead th:nth-child(2) {
        width: 320px;
    }

    thead th:last-child {
        border-top-right-radius: 20px;
    }

    .apill {
        min-width: 150px;
    }

    .apill--reingreso {
        background-color: #baece6;
        color: #16beaa;
    }

    .apill--ingreso {
        background-color: #ffeed4;
        color: #ffa928;
    }

    .fbutton {
        border: none;
        width: 35px;
        height: 35px;
    }

    .fbutton--edit {
        background-color: #e3f7e2;
        color: #65cd65;
    }

    .fbutton--delete {
        background-color: #ffe4e6;
        color: #ff4757;
    }
}
</style>
